/** 获取当前页面z-index最高的层级 */
// export function getMaxZIndex () {
//   let arr = [...document.all].map(e => +window.getComputedStyle(e).zIndex || 0)
//   return arr.length ? Math.max(...arr) + 1 : 0
// }

// export function removeDom (dom) {
//   if (!dom) return
//   dom.parentNode.removeChild(dom)
// }

// export function showDialog (value, title, solo = false) {
//   const html = `<div class="posi-f t0 b0 l0 r0 flex flex-center">
//       <div class="posi-a t0 b0 l0 r0 bg-0-5"></div>
//       <div class="posi-r bg-f w90 br-ra-20">
//         <div class="h-100 flex-center flex fon-size-30">${title || '提示'}</div>
//         <div class="pad-l-30 pad-r-30 pad-t-30 pad-b-30 br-b-e t-c fon-size-28 lineH-32 min-h-100">${value}</div>
//         <div class="flex flex-bt br-t-e">
//           ${!solo ? ' <span class="fon-size-30 flex-1 h-100 flex-center flex posi-r after-line-e" id="dislog-cancel">取消</span>' : ''}
//           <span class="fon-size-30 flex-1 h-100 flex-center flex col-main" id="dislog-confirm">确认</span>
//         </div>
//       </div>
//     </div>`

//   const dialogDom = document.createElement('div')
//   dialogDom.style.zIndex = getMaxZIndex()
//   dialogDom.innerHTML = html
//   document.body.appendChild(dialogDom)

//   return new Promise((resolve, reject) => {
//     const confirm = document.querySelector('#dislog-confirm'),
//       cancel = document.querySelector('#dislog-cancel')

//     confirm.onclick = () => {
//       removeDom(dialogDom)
//       resolve(true)
//     }

//     if (!solo) {
//       cancel.onclick = () => {
//         removeDom(dialogDom)
//         resolve(false)
//       }
//     }
//   })

// }

// export function operation ({list = [], callBack}) {

//   let operationList = ''

//   list.forEach((item, i) => {
//     operationList += `<li class="flex flex-y-center pad-l-30 pad-r-30 h-100 fon-size-36 col-6 operation-item" data-index="${i}">
//                         <div class="w-120 t-c">
//                           ${item.icon ? `<i class="iconfont ${item.icon}"></i>` : ''}
//                           ${item.image ? `<img src="${item.icon}"/>` : ''}
//                         </div>${item.name}
//                       </li>`
//   })

//   const html = `<div class="posi-f t0 b0 l0 r0 flex flex-center">
//                   <div class="posi-a t0 b0 l0 r0 bg-0-5" id="operation-cover"></div>
//                   <ul class="bg-f posi-a b0 w100 bg-f">${operationList}</ul>
//                 </div>`

//   const operationDom = document.createElement('div')
//   operationDom.style.zIndex = getMaxZIndex()
//   operationDom.innerHTML = html
//   document.body.appendChild(operationDom)

//   const cover = document.querySelector('#operation-cover'),
//     operationItem = document.querySelectorAll('.operation-item')

//   return new Promise((resolve, reject) => {
//     cover.onclick = () => {
//       removeDom(operationDom)
//       resolve(false)
//     }
//     operationItem.forEach((item, index) => {
//       item.onclick = () => {
//         callBack && callBack({...list[index], index})
//         removeDom(operationDom)
//         resolve({...list[index], index})
//       }
//     })
//   })
// }

/**
 * 获取数据类型
 * */
export function getType (obj, str) {
  let t = Object.prototype.toString.call(o).split(' ')[1]
  t = t.substring(0, t.length - 1).trim().toLowerCase()
  if (t === 'object' && Object.prototype.toString.call(o).toLowerCase() === '[object object]' && !o.length) t = 'json'
  return s ? t === s : t
}

// /** 获取正确的数据格式，
//  *  如果传进来的数据格式是正确的就返回自身，
//  *  如果不是就进行返回一个需要的数据格式
//  *  */
// export function getSuccessData (obj, type) {
//   let itemType = getType(obj)
//   if (getType(type) != 'string') type = getType(type)
//   if (itemType == type) return obj
//   switch (type) {
//     case 'array':
//       return []
//     case 'json':
//       return {}
//     case 'string':
//       return ''
//     case 'number':
//       return 0
//     case 'function':
//       return () => {
//       }
//   }
// }

// /** 判断手机号 */
// export function isPhone (tel) {
//   const teleReg = /^((0\d{2,3})-)(\d{7,8})$/,
//     mobileReg = /^1[3456789]\d{9}$/

//   return !(!teleReg.test(tel) && !mobileReg.test(tel))
// }

// /** 判断手机号 */
// export function isMobilePhone (tel) {
//   const mobileReg = /^1[3456789]\d{9}$/
//   return !(!mobileReg.test(tel))
// }

// /**
//  * 时间戳格式转换以及计算
//  * */
// export function formatTime (time = 0, format = 'YYYY-MM-DD hh:mm:ss') {

//   const now = new Date().getTime()

//   if (!time) time = now

//   while (time.toString().length < 13) time += '0'

//   const date = new Date(time)

//   date.getMonth()

//   const arg = {
//     year: date.getFullYear(),
//     month: date.getMonth() + 1,
//     day: date.getDay(),
//     hours: date.getHours(),
//     minutes: date.getMinutes(),
//     seconds: date.getSeconds()
//   }

//   switch (format) {
//     case 'YYYY-MM-DD hh:mm:ss':
//       return `${arg.year}-${arg.month}-${arg.day} ${arg.hours}:${arg.minutes}:${arg.seconds}`
//     case 'YYYY-MM-DD':
//       return `${arg.year}-${arg.month}-${arg.day}`
//     case 'MM-DD':
//       return `${arg.month}-${arg.day}`
//     case 'hh:mm:ss':
//       return `${arg.hours}:${arg.minutes}:${arg.seconds}`
//     case 'hh:mm':
//       return `${arg.hours}:${arg.minutes}`
//     case 'computed':
//       if (now > time) {
//         const dt = Math.abs(time - now),    //时间已过去多少毫秒
//           S = dt / 1000,    //秒
//           M = S / 60,  //分
//           H = M / 60,  //小时
//           D = H / 24,   //天
//           W = D / 7    //周

//         if (~~W > 0 && W < 3) {
//           return ~~W + '周前'
//         } else if (D < 7 && ~~D > 0) {
//           return ~~D + '天前'
//         } else if (~~H > 0 && H < 24) {
//           return ~~H + '小时前'
//         } else if (~~M > 0 && M < 60) {
//           return ~~M + '分钟前'
//         } else if (~~S > 0 && S < 60) {
//           return ~~S + '秒前'
//         }
//       } else {
//         console.log('未来的时间')
//       }
//       return `${arg.year}-${arg.month}-${arg.day} ${arg.hours}:${arg.minutes}:${arg.seconds}`
//   }
// }

// /** 给元素绑定TOUCH事件 */
// export function touch ({dom, start, move, end, stop = true, change}) {
//   const f = {
//     data: {},
//     start (e) {						//手指触碰的屏幕就会触发(一次)
//       stop && e.preventDefault()		//阻止冒泡，当stop为false的时候就运行冒泡，默认为true
//       f.data = {						//储存的是一些数据
//         ...f.data,					//扩展运算，将之前的数据进行合并
//         x: e.touches[0].pageX,		//手指开始的横向位置
//         y: e.touches[0].pageY,		//手指开始的纵向位置
//         ex: 0,						//手指结束的横向位置
//         ey: 0,						//手指结束的纵向位置
//         time: new Date().getTime()	//手指的开始时间
//       }
//       start && start(f.data)		//执行自定义的 start 方法
//     },
//     move (e) {					//多次
//       stop && e.preventDefault()		//阻止冒泡，当stop为false的时候就运行冒泡，默认为true
//       f.data = {				//储存的是一些数据
//         ...f.data,			//扩展运算，将之前的数据进行合并
//         ex: e.touches[0].pageX,			//手指结束的横向位置
//         ey: e.touches[0].pageY,			//手指结束的纵向位置
//       }
//       move && move({					//执行自定义的 move方法，并且把得到的数据进行返回
//         x: e.touches[0].pageX,
//         y: e.touches[0].pageY,
//         dx: f.data.ex - f.data.x,
//         dy: f.data.ey - f.data.y
//       })
//     },
//     end (e) {				//手指离开屏幕就会触发(一次)
//       stop && e.preventDefault()		//阻止冒泡，当stop为false的时候就运行冒泡，默认为true
//       let time = new Date().getTime()	//手指离开的时间
//       end && end({				//执行自定义的 end 方法，并且把得到的数据进行返回
//         time,					//当前时间
//         startTime: f.data.time,		//手指的开始时间
//         dt: time - f.data.time,			//手指在屏幕逗留的时间差 ms
//         dy: (f.data.ey || f.data.y) - f.data.y,		//手指在屏幕上的纵向的移动距离
//         dx: (f.data.ex || f.data.x) - f.data.x		//手指在屏幕上的横向的移动距离
//       })

//       // ↓ 下面的就是执行判断手指移动的方向，当达到条件，就会执行change事件，
//       // change 返回的参数
//       //  	direction: left | right | up | down | origin
//       if (new Date().getTime() - f.data.time < 300) {		// 手指开屏幕上的时间很短

//         if (Math.abs(f.data.ex - f.data.x) > 20 && Math.abs(f.data.ex - f.data.x) > Math.abs(f.data.ey - f.data.y)) {
//           if (change) {
//             if (f.data.ex > f.data.x) {
//               change({
//                 direction: 'right'
//               })
//             } else if (f.data.ex < f.data.x) {
//               change({
//                 direction: 'left'
//               })
//             }
//           }
//         } else if (Math.abs(f.data.ey - f.data.y) > 20 && Math.abs(f.data.ex - f.data.x) < Math.abs(f.data.ey - f.data.y)) {
//           if (change) {
//             if (f.data.ey > f.data.y) {
//               change({
//                 direction: 'down'
//               })
//             } else if (f.data.ey < f.data.y) {
//               change({
//                 direction: 'up'
//               })
//             }
//           }
//         } else {
//           change && change({
//             direction: 'origin'
//           })
//         }
//       } else if (Math.abs(f.data.ey - f.data.y) >= 50) {
//         if (change) {
//           if (f.data.ey > f.data.y) {
//             change({
//               direction: 'down'
//             })
//           } else if (f.data.ey < f.data.y) {
//             change({
//               direction: 'up'
//             })
//           }
//         }
//       } else if (Math.abs(f.data.ex - f.data.x) >= 50) {
//         if (change) {
//           if (f.data.ex > f.data.x) {
//             change({
//               direction: 'right'
//             })
//           } else if (f.data.ex < f.data.x) {
//             change({
//               direction: 'left'
//             })
//           }
//         }
//       } else {
//         change && change({
//           direction: 'origin'
//         })
//       }
//     }
//   }
//   // 这里是防止dom元素绑定事件异常，导致整体页面无法正常往下执行
//   try {
//     dom.removeEventListener('touchstart', f.start)
//     dom.addEventListener('touchstart', f.start)
//     dom.removeEventListener('touchmove', f.move)
//     dom.addEventListener('touchmove', f.move)
//     dom.removeEventListener('touchend', f.end)
//     dom.addEventListener('touchend', f.end)
//   } catch (e) {
//     console.error('给dom元素绑定事件的时候出现了错误', e)
//   }
// }

// export function getAttrs (dom) {
//   let attrs = new Object(null)
//   if (getType(dom, 'dom')) {
//     let attrsMap = dom.attributes
//     for (let a in attrsMap) {
//       let val = attrsMap[a].nodeValue
//       if (val) {
//         attrs[attrsMap[a].name] = val
//       }
//     }
//   }
//   return attrs
// }

// 这里存放所有公共方法的类
const toolRex = {
  /** 正则校验表达式开始 */
  //校验手机号
  mobileRex: /^1[3456789]\d{9}$/,
  /**校验整数或小数
   * 1、除了个位，十位以上不能以0开头
     2、小数部分可有可元
     3、小数点后可以一位或者二位
   */
  numberRex:/^([1-9]\d*|0)(\.\d{1,2})?$/,

  /** 正则校验表达式结束 */

  /** 公共方法开始 */
  //校验是否为空
  isCommonEmpty:function(){
    return _.isEmpty(str);
  },

  /**
   * 比较两个日期相差天数 日期格式为 yyyy/MM/dd
   * @param {} strDateStart
   * @param {} strDateEnd
   * @return {}
   */
  getDifferDays:function(strDateStart,strDateEnd){
    var strSeparator = "/"; //日期分隔符
    var oDate1;
    var oDate2;
    var iDays;
    oDate1= strDateStart.split(strSeparator);
    oDate2= strDateEnd.split(strSeparator);
    var strDateS = new Date(oDate1[0], oDate1[1]-1, oDate1[2]);
    var strDateE = new Date(oDate2[0], oDate2[1]-1, oDate2[2]);
    iDays = parseInt(Math.abs(strDateS - strDateE ) / 1000 / 60 / 60 /24)//把相差的毫秒数转换为天数
    return iDays;
  },



  /** 公共方法结束 */
}

export { toolRex }


/**
 * 格式化金额,例：20 => 20.00
 */
export function fnFormaMoney (str) {
  var rtn = "";
  var num = "";
  if(str == null || typeof(str) == undefined || isNaN(str) || str == 0) {
    rtn = "0.00";
    return rtn;
  } else {
    if(parseFloat(str) < 0){
      str = Math.abs(parseFloat(str));
      if(parseFloat(str) < 0.1){
        return "-" + str;
      }else{
        num = (Number(str) * 100).toFixed(0).toString();
      }
      rtn = num.substring(0, num.length - 2) + "." + num.substring(num.length - 2);
      if(rtn.indexOf('.') == 0) {
        rtn = "-0" + rtn;
      }else{
        rtn = "-" + rtn;
      }
    }else{
      if(parseFloat(str) < 0.1){
        return str;
      }else{
        num = (Number(str) * 100).toFixed(0).toString();
      }
      rtn = num.substring(0, num.length - 2) + "." + num.substring(num.length - 2);
      if(rtn.indexOf('.') == 0) {
        rtn = "0" + rtn;
      }
    }
  }
  return rtn;
}

/**
 * 保留2位小数,不补0，如：2，会在2后面补上00.即2.00  3.145 = 3.15  3.144 = 3.14
 * xb
 */
 export function toDecimalNoZero2(x) {
	if(x == null || x == undefined){
		return "0";
	}
	var f = parseFloat(x);
	if (isNaN(f)) {
		return false;
	}
	// 20200907 liuchun 修改 防止出现科学技术发导致四舍五入错误，如4.765 * 100 结果为476.499999999，所以这里在乘100后，直接保留一位小数，保证四舍五入的正确性 BUG 17451
	var x_100 = (parseFloat(x) * 100).toFixed(1);
	var f = Math.round(x_100)/100;
	var s = f.toString();
	return s;
}


/**
 * 格式金额显示，过万显示 n万，不补0
 */
 export function fnFormatMoneyForWanNoZero (str) {
  str = this.fnFormaMoney(str)+"";
  var rtn = "";
  if(str == null || typeof(str) == undefined || isNaN(str) || str == 0) {
    rtn = "0";
    return rtn;
  } else {
    if(parseFloat(str) >= 10000){
      str = toDecimalNoZero2((Number(str)/10000).toFixed(2)).toString();
      // str = str.substring(0, str.length-7);
      rtn = str + "万";
    }else{
      rtn = toDecimalNoZero2(str);
    }
  }
  return rtn;
}

/**
 * 格式金额显示，过万显示 n万
 */
 export function fnFormatMoneyForWan (str) {
  str = this.fnFormaMoney(str)+"";
  var rtn = "";
  if(str == null || typeof(str) == undefined || isNaN(str) || str == 0) {
    rtn = "0";
    return rtn;
  } else {
    if(parseFloat(str) >= 10000){
      str = (Number(str)/10000).toFixed(2).toString();
      // str = str.substring(0, str.length-7);
      rtn = str + "万";
    }else{
      rtn = str;
    }
  }
  return rtn;
}

/**
 * 格式化库存显示，过万显示 n万
 */
export function fnFormaStockNum (str) {
  str = str+"";
  var rtn = "";
  if(str == null || typeof(str) == undefined || isNaN(str) || str == 0) {
    rtn = "0";
    return rtn;
  } else {
    if(parseFloat(str) >= 10000){
      str = str.substring(0, str.length-4);
      rtn = str + "万";
    }else{
      rtn = str;
    }
  }
  return rtn;
}



//加法
export  function fnAdd(num1, num2) {
  var r1, r2, m;
  try { r1 = num1.toString().split(".")[1].length } catch (e) { r1 = 0 }
  try { r2 = num2.toString().split(".")[1].length } catch (e) { r2 = 0 }
  m = Math.pow(10, Math.max(r1, r2))
  return (num1 * m + num2 * m) / m
}

//减法
export function fnSub(num1, num2) {
  return fnAdd(num1, -num2);
}

//乘法
export function fnMul(num1, num2) {
  var m = 0, s1 = num1.toString(), s2 = num2.toString();
  try { m += s1.split(".")[1].length } catch (e) { }
  try { m += s2.split(".")[1].length } catch (e) { }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}

//除法
export function fnDiv(num1, num2) {
  var t1 = 0, t2 = 0, r1, r2;
  try { t1 = num1.toString().split(".")[1].length } catch (e) { }
  try { t2 = num2.toString().split(".")[1].length } catch (e) { }
  r1 = Number(num1.toString().replace(".", ""))
  r2 = Number(num2.toString().replace(".", ""))
  return (r1 / r2) * Math.pow(10, t2 - t1);

}

/** 阻止冒泡*/
export function fnStopBub(e){
  if (e && e.stopPropagation) {
    e.stopPropagation(); // 非IE浏览器
  } else {
    e.cancelBubble = true; //IE浏览器
  }
}

//判断是否是微信浏览器
export function isWeixin(){
  const ua = window.navigator.userAgent.toLowerCase();
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    return true;
  } else {
    return false;
  }
}

/**
 * 截取字符串显示
 */
export function fnGetSubStr(str,num) {
  if(str != null && str != ""){
    if(str.length > num){
      if(str.length == (num+1)){
        return str;
      }else{
        return  str.substring(0,num)+"...";
      }
    }else{
      return str;
    }
  }
}
/**
 * 拼装显示的图片路径
 *
 */
export function fnShowImg(fileServerUrl,imgUrl){
  if(fileServerUrl != null && fileServerUrl != ""){
    return fileServerUrl+"/"+imgUrl;
  }else{
    return imgUrl;
  }
}

export function timeTrunName(time){
  var currentTime = Date.parse(new Date());
  var dateTime = time;//后台传递来的时间
  var ts = "刚刚";//选择器
  var d_day = Date.parse(new Date(dateTime));
  var day = Math.abs(parseInt((d_day - currentTime)/1000/3600/24));//计算日期
  var hour = Math.abs(parseInt((d_day - currentTime)/1000/3600));//计算小时
  var minutes = Math.abs(parseInt((d_day - currentTime)/1000/60));//计算分钟
  var seconds = Math.abs(parseInt((d_day - currentTime)/1000));//计算秒
  console.log(day);
  if(day > 99){
    ts = "99+天";
  }else if(day > 0 && day <= 99){
    ts = parseInt(day)+"天前";
  }else if(day > 0 && day < 2){
    ts = "昨天";
  }else if(hour > 0 && hour < 24){
    ts = parseInt(hour)+"小时前";
  }else if(minutes > 0 && minutes < 60){
    ts = parseInt(minutes)+"分钟前";
  }else if(seconds > 0 && seconds < 60){
    ts = parseInt(seconds)+"秒前";
  }
  return ts;
}



const commonTool = {
  generateUUID () {
    var d = new Date().getTime()
    if (window.performance && typeof window.performance.now === 'function') {
      d += performance.now()
    }
    var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
    return uuid
  },
  getFileType (fixName) {
    if (fixName.toLowerCase() == 'png' || fixName.toLowerCase() == 'jpg' || fixName.toLowerCase() == 'jpeg' || fixName.toLowerCase() == 'bmp') {
      return '00001'
    } if (fixName.toLowerCase() == 'cdr') {
      return '00002'
    } else if (fixName.toLowerCase() == 'psd') {
      return '00003'
    } else if (fixName.toLowerCase() == 'ai') {
      return '00004'
    } else if (fixName.toLowerCase() == 'doc' || fixName.toLowerCase() == 'docx' || fixName.toLowerCase() == 'xls' || fixName.toLowerCase() == 'xlsx' || fixName.toLowerCase() == 'ppt'  || fixName.toLowerCase() == 'pptx') {
      return '00005'
    }else if (fixName.toLowerCase() == 'dwt' || fixName.toLowerCase() == 'dwg' || fixName.toLowerCase() == 'dws' || fixName.toLowerCase() == 'dxf') {
      return '00006'
    } else {
      return '99999'
    }
  }
}

export { commonTool }



// WEBPACK FOOTER //
// ./src/util/base.js